import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'filterText': '',
  'list': [],
  'filteredList': [],
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
};

export const pncVehicles = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_VEHICLE_LIST_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCH_VEHICLE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCH_VEHICLE_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
